// based on rc-notification 3.3.0
import Notification from './Notification';
export default Notification;
